// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"13faea6d","178":"9f49d4e8","413":"3c48c999","444":"c3e4f73d","668":"ce4962a4","936":"0c4645f0","970":"80ba5073"}[chunkId] + ".chunk.css";
};